export const calcularQtdDependentesConjuge = dependentes => {
    const dependentesConjuge = dependentes.filter(
        dependente => dependente['GrauParentesco.Grau'].trim() === '10'
    );

    return dependentesConjuge;
};

export const validatorMaior79Anos = valoresForm => {
    const arrayDeValidacoes = [

        idadeAcima79(valoresForm.Idade),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAcima79(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorAte64Anos = valoresForm =>{
    const arrayDeValidacoes = [
      
        idadeAte64(valoresForm.Idade),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte64(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaiorIgual65Anos = valoresForm =>{
    const arrayDeValidacoes = [
      
        idadeAte65(valoresForm.Idade),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte65(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificarIdadePreenchida = idade => idade !== '' && idade !== null;
const verificarCategoriaPrenchida = categoria => categoria !== '';
const verificarSemAdicional = categoria => categoria.trim() === 'ZELO';
const verificarAdicionalAte64 = categoria => categoria.trim() !== 'ZTA64';
const verificarAdicionalAte65 = categoria => categoria.trim() !== 'ZTA65' && categoria.trim() !== 'ZTM65';
const verificarAdicionalAcima79 = categoria => categoria.trim() !== 'ZTA79';
const idadeAte64 = idade => idade <= 64;
const idadeAte65 = idade => idade > 65; //&& idade <= 79;
const idadeAcima79 = idade => idade > 79;
